import React, { useEffect, useRef, useState } from 'react';
import LogoSingle from 'assets/images/pmix-logo-single.svg';
import { useDispatch, useSelector } from 'react-redux';
import QuickActions from 'ui-component/quick-actions/QuickActions';
import { storeHeaderActions } from 'store/reducers/mainSlice';
import { FiSearch } from 'react-icons/fi';
import { HiOutlineDeviceMobile } from 'react-icons/hi';
import Tags from 'ui-component/Tags';
import { motion } from 'framer-motion';
import {
	ArrowRightIcon,
	QuotationIcon,
	SalesOrderIcon,
	InvoiceIcon,
	ContactsIcons,
	PurchaseListIcon,
	SerialsIcon,
	TrackingCodeIcon,
} from 'ui-component/custom-icons/icons';
import { Skeleton } from '@mui/material';
import { CountriesUIFlag } from 'ui-component/CountriesUI';
import { useNavigate } from 'react-router';

// ✅ Clear
const HeaderMobile = () => {
	const searchInputRef = useRef();
	const pageTitle = useSelector((state) => state.main.pageTitle);
	const dispatch = useDispatch();
	const [searchExpand, setSearchExpand] = useState(false);
	const [showActions, setShowActions] = useState(false);
	const history = useNavigate();
	
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [generalSearchValue, setGeneralSearchValue] = useState('');
	const [isSearchInProgress, setIsSearchInProgress] = useState(false);

	const [showQuotationSection, setShowQuotationSection] = useState(true);
	const [showSalesOrderSection, setShowSalesOrderSection] = useState(true);
	const [showInvoiceSection, setShowInvoiceSection] = useState(true);
	const [showContactSection, setShowContactSection] = useState(true);
	const [showProductSection, setShowProductSection] = useState(true);
	const [showPurchaseOrderSection, setShowPurchaseOrderSection] = useState(true);
	const [showImeiSection, setShowImeiSection] = useState(true);
	const [showTrackingNumberSection, setShowTrackingNumberSection] = useState(true);

	const [searchResultQuotation, setSearchResultQuotation] = useState([]);
	const [searchResultSalesOrder, setSearchResultSalesOrder] = useState([]);
	const [searchResultInvoice, setSearchResultInvoice] = useState([]);
	const [searchResultContact, setSearchResultContact] = useState([]);
	const [searchResultProduct, setSearchResultProduct] = useState([]);
	const [searchResultPurchaseOrder, setSearchResultPurchaseOrder] = useState([]);
	const [searchResultImei, setSearchResultImei] = useState([]);
	const [searchResultTrackingNumber, setSearchResultTrackingNumber] = useState([]);

	const handleSearchExpand = () => {
		if (!searchExpand) setShowActions(false); // Close actions if opening search
		setSearchExpand((prev) => !prev);
	};

	useEffect(() => {
		dispatch(
			storeHeaderActions({
				showQuickStats: false,
				showExport: false
			})
		);
	}, []);


	const handleSearchSubmit = (e) => {
		e.preventDefault();
	};


	useEffect(() => {
	const handleResize = () => {
		const isMobile = window.innerWidth <= 768;
		document.body.style.overflow = isMobile ? 'hidden' : '';
	};
	handleResize(); // Run on mount
	window.addEventListener('resize', handleResize);
	return () => {
		window.removeEventListener('resize', handleResize);
		document.body.style.overflow = '';
	};
	}, []);
	
	
	const getGeneralSearch = () => {
		setIsSearchInProgress(true);
		// api.getGenerealSearchContent({ search: generalSearchValue.trim() }).then((res) => {
		// 	if (res?.status) {
		// 		setShowQuotationSection(res?.data?.has_quotations);
		// 		setShowSalesOrderSection(res?.data?.has_sales_orders);
		// 		setShowInvoiceSection(res?.data?.has_invoices);
		// 		setShowContactSection(res?.data?.has_contacts);
		// 		setShowProductSection(res?.data?.has_products);
		// 		setShowPurchaseOrderSection(res?.data?.has_purchase_orders);
		// 		setShowImeiSection(res?.data?.has_imeis);
		// 		setShowTrackingNumberSection(res?.data?.has_tracking_numbers);

		// 		setSearchResultQuotation(res?.data?.quotations || []);
		// 		setSearchResultSalesOrder(res?.data?.sales_orders || []);
		// 		setSearchResultInvoice(res?.data?.invoices || []);
		// 		setSearchResultContact(res?.data?.contacts || []);
		// 		setSearchResultProduct(res?.data?.products || []);
		// 		setSearchResultPurchaseOrder(res?.data?.purchase_orders || []);
		// 		setSearchResultImei(res?.data?.imeis || []);
		// 		setSearchResultTrackingNumber(res?.data?.tracking_numbers || []);

		// 		let totalSections = 0;
		// 		if (res?.data?.has_quotations) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_sales_orders) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_invoices) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_contacts) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_products) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_purchase_orders) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_imeis) {
		// 			totalSections += 1;
		// 		}
		// 		if (res?.data?.has_tracking_numbers) {
		// 			totalSections += 1;
		// 		}

		// 	}
		// 	setIsSearchInProgress(false);
		// });
	};

		 useEffect(() => {
			if (searchTimeout) clearTimeout(searchTimeout);
			if (generalSearchValue === '') return; // Don't search on empty
	
			const timeout = setTimeout(() => {
				getGeneralSearch();
			}, 500);
	
			setSearchTimeout(timeout);
	
			return () => clearTimeout(timeout);
		}, [generalSearchValue, location]);
	
		useEffect(() => {
			if (generalSearchValue.trim() === '') {
				getGeneralSearch();
			}
		}, [generalSearchValue])
	

	return (
		<header className="mobileHead">
			{/* <img
				src={LogoSingle}
				alt="Logo"
				style={{ maxWidth: '100%', height: '32px', cursor: 'pointer' }}
				onClick={() => history('/dashboard')}
			/> */}
			<div className="d-flex justify-content-center align-items-center" style={{ gap: '5px' }}>
				{/* <div style={{ fontSize: '18px', lineHeight: '1' }}>
					<QuickActions
						showActions={showActions}
						setShowActions={setShowActions}
						searchExpand={searchExpand}
						setSearchExpand={setSearchExpand}
					/>
				</div>
				<div className="btn-new-mobile btn-secondary" onClick={handleSearchExpand}>
					<FiSearch size={16} />
				</div> */}
			</div>
			<motion.div
				initial={{ opacity: 0 }}
				animate={searchExpand ? { opacity: 1, pointerEvents: 'auto' } : { opacity: 0, pointerEvents: 'none' }}
				transition={{ duration: 0.3, ease: 'easeInOut' }}
				className="new-blur-div"
				onClick={() => setSearchExpand(false)} // Optional: click to close search
			/>

			{/* Search panel */}
			<motion.div
				initial={{ height: 0 }}
				animate={searchExpand ? { height: '75dvh' } : { height: 0 }}
				transition={{ duration: 0.3, ease: 'easeInOut' }}
				className="new-search-div"
			>
				<form onSubmit={handleSearchSubmit}>
					<div className="form-group mb-1" style={{ position: 'relative', paddingInline: '20px', marginTop: '10px !important' }}>
						<input
							type="search"
							className="form-control search-input-black"
							placeholder="Search..."
							ref={searchInputRef}
							value={generalSearchValue}
							onChange={(e) => {
								setIsSearchInProgress(true);
								setShowQuotationSection(true);
								setShowInvoiceSection(true);
								setShowProductSection(true);
								setShowImeiSection(true);
								setShowSalesOrderSection(true);
								setShowContactSection(true);
								setShowPurchaseOrderSection(true);
								setShowTrackingNumberSection(true);
								setGeneralSearchValue(e.target.value);
							}}
							style={{ paddingRight: '36px' }} // Add space for the icon
						/>
						<span
							style={{
								position: 'absolute',
								right: '30px',
								top: '50%',
								transform: 'translateY(-50%)',
								color: 'black',
								pointerEvents: 'none', // So clicks go to the input
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center'
							}}
						>
							<FiSearch size={16} />
						</span>
					</div>
				</form>

				<div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(75dvh - 60px)', overflowY: 'auto', padding: 10 }}>
					{generalSearchValue.trim() !== '' && (
						<>
							{showQuotationSection ||
							showInvoiceSection ||
							showProductSection ||
							showImeiSection ||
							showSalesOrderSection ||
							showContactSection ||
							showPurchaseOrderSection ||
							showTrackingNumberSection ? (
								<>
									{showQuotationSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<QuotationIcon height="14px" width="14px" />
													</div>
													<div>QUOTATION</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultQuotation.length > 0 && (
														searchResultQuotation.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/sales/quotations/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultQuotation.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/sales/quotations`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showSalesOrderSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<SalesOrderIcon height="14px" width="14px" />
													</div>
													<div>SALES ORDERS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultSalesOrder.length > 0 && (
														searchResultSalesOrder.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/sales/sales-orders/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultSalesOrder.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/sales/sales-orders`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showInvoiceSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<InvoiceIcon height="14px" width="14px" />
													</div>
													<div>INVOICES</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultInvoice.length > 0 && (
														searchResultInvoice.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/sales/invoices/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultInvoice.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/sales/invoices`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showContactSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<ContactsIcons height="14px" width="14px" />
													</div>
													<div>CONTACTS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultContact.length > 0 && (
														searchResultContact.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/contacts/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									tag?.key === 'Country' ? (
																										<div style={{ padding: '0px 5px', fontSize: '16px' }}>
																											<CountriesUIFlag countryName={`${tag?.value}`} />
																										</div>
																									) : (
																										<div className="general-search-tag-container text-gray-800">
																											{tag?.value}
																										</div>
																									)
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultContact.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/contacts`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showPurchaseOrderSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<PurchaseListIcon height="14px" width="14px" />
													</div>
													<div>PURCHASE ORDERS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultPurchaseOrder.length > 0 && (
														searchResultPurchaseOrder.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/purchasing/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultPurchaseOrder.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/purchasing`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showProductSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<HiOutlineDeviceMobile style={{ fontSize: '1.3em' }} />
													</div>
													<div>PRODUCTS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultProduct.length > 0 && (
														searchResultProduct.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/products/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultProduct.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/products`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showImeiSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<SerialsIcon height="14px" width="14px" />
													</div>
													<div>IMEIS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultImei.length > 0 && (
														searchResultImei.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/serials/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag?.value && (
																									<Tags label={tag?.value} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultImei.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/serials`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
									{showTrackingNumberSection && (
										<>
											<div className="col-12 general-search-title">
												<div className="flex align-items-center gap-3">
													<div>
														<TrackingCodeIcon height="14px" width="14px" />
													</div>
													<div>TRACKING NUMBERS</div>
												</div>
											</div>
											{isSearchInProgress ? (
												<>
													{[...Array(5)].map((e, i) => (
														<div className="col-12" style={{ padding: '3px 10px' }}>
															<div className="flex gap-2 w-full">
																<Skeleton variant="text" width="100%" height={'20px'} />
															</div>
														</div>
													))}
													<div style={{ height: '25px' }}></div>
												</>
											) : (
												<>
													{searchResultTrackingNumber.length > 0 && (
														searchResultTrackingNumber.map((item, index) => (
															<div className="col-12 general-search-result-row" key={index}>
																<div
																	className="flex gap-2 w-full"
																	onClick={() => {
																		item?.id && history(`/shipments/${item?.id}`);
																		setShowSearchContainer(false);
																	}}
																>
																	<div>
																		<ArrowRightIcon width="18px" height="18px" />
																	</div>
																	<div className="w-full">
																		<a href="javascript:void(0);" className="fw-400 search-result-link">
																			<div className="d-flex align-items-center gap-2">
																				<div className="general-search-result" style={{ width: '100%' }}>
																					<div
																						className="d-flex align-items-center gap-2 justify-content-between"
																						style={{ marginTop: '-3px' }}
																					>
																						<div className="general-search-result-value">{item?.value}</div>
																						<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																							{item?.tags?.map((tag, idx) => (
																								tag && (
																									<Tags label={tag} />
																								)
																							))}
																						</div>
																					</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														))
													)}
													{searchResultTrackingNumber.length > 9 && (
														<div
															className="col-12 mb-2 general-search-result-row"
															style={{ fontSize: '13px' }}
															onClick={() => {
																history(`/shipments`);
																setShowSearchContainer(false);
															}}
														>
															<a href="javascript:void(0);">See More...</a>
														</div>
													)}
												</>
											)}
										</>
									)}
								</>
							) : (
								<div className="col-12">
									<div className="no-general-search-result">
										<div>No search result found for: </div>
										<div className="fw-500 text-gray-900 ">{generalSearchValue}</div>
									</div>
								</div>
							)}
						</>
					)}
				</div>
			</motion.div>
		</header>
	);
};

export default HeaderMobile;
